import {
  SUBMIT_DROPDOWN_START,
  SUBMIT_DROPDOWN_SUCCESS,
  SUBMIT_DROPDOWN_ERROR,
  FETCH_DROPDOWN_START,
  FETCH_DROPDOWN_SUCCESS,
  FETCH_DROPDOWN_ERROR,
  DELETE_DROPDOWN_START,
  DELETE_DROPDOWN_SUCCESS,
  UPDATE_DROPDOWN_START,
  UPDATE_DROPDOWN_SUCCESS,
  DELETE_DROPDOWN_ERROR,
  UPDATE_DROPDOWN_ERROR,
} from "../types";

const initialState = {
  dropdownData: [],
  isLoading: false,
  error: null,
};

const dropdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_DROPDOWN_START:
    case FETCH_DROPDOWN_START:
    case UPDATE_DROPDOWN_START:
    case DELETE_DROPDOWN_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case SUBMIT_DROPDOWN_SUCCESS:
    case UPDATE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case FETCH_DROPDOWN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dropdownData: action.payload,
      };
    case DELETE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dropdownData: state.dropdownData.filter(
          (dropdown) => dropdown.id !== action.payload
        ),
      };
    case SUBMIT_DROPDOWN_ERROR:
    case FETCH_DROPDOWN_ERROR:
    case DELETE_DROPDOWN_ERROR:
    case UPDATE_DROPDOWN_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default dropdownReducer;
